var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row align-items-center mt-3" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _vm._v("\r\n\t\t\t\t\tKontakt\r\n\t\t\t\t"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-4", attrs: { id: "contact2" } },
                [
                  _c("hr", { attrs: { align: "left", width: "50%" } }),
                  _vm._v(" "),
                  _c("h4", { staticClass: "pt-2" }, [_vm._v("Aquadrat GbR")]),
                  _vm._v(" "),
                  _c("b-icon-globe2"),
                  _vm._v("Pfaffenschlag 10, 96114 Hirschaid"),
                  _c("br"),
                  _vm._v(" "),
                  _c("h4", { staticClass: "pt-2" }, [_vm._v("Kontakt")]),
                  _vm._v(" "),
                  _c("b-icon-telephone-fill"),
                  _c("a", { attrs: { href: "tel:+4991192867652" } }, [
                    _vm._v(" + 49 (0) 911 92 86 76 52 "),
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("h4", { staticClass: "pt-2" }, [_vm._v("Email")]),
                  _vm._v(" "),
                  _c("b-icon-envelope-fill"),
                  _vm._v(" "),
                  _c("a", { attrs: { href: "" } }, [
                    _vm._v("Florian@Leuchtenstern.com"),
                  ]),
                  _c("br"),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row align-items-center mt-3" }, [
      _vm._v("\r\n\t\t \r\n\t"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }